'use es6';

import { memo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { CTA_PERFORMANCE, LanguageCTALinks } from '../../constants/TrialConstants';
import ResultHeaderIllustration from './ResultHeaderIllustration';
import ResultSection from './ResultSection';
import PageScore from '../PageScore';
import Subtitle from '../Subtitle';
import ScoreConstants from '../../constants/ScoreConstants';
import PerformanceData from '../../data/PerformanceData';
import ResultCtaBanner from '../ResultCtaBanner';
import { parseUtmParams } from '../../util/Urls';
import usageTracker from '../../lib/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CTAButton = /*#__PURE__*/memo(({
  websiteUrl
}) => {
  const lang = window.I18N_MANUAL_LANG;
  const isEn = lang === 'en';
  const alt = isEn ? '' : '-alt';
  const url = isEn ? CTA_PERFORMANCE : LanguageCTALinks[lang];
  const parsedUtmParams = parseUtmParams();
  const handleClick = () => {
    const eventKey = isEn ? 'academyCourseClick' : 'freeGuideClick';
    const action = isEn ? 'clicked-free-lesson-link' : 'clicked-get-guide-link';
    usageTracker.log(eventKey, {
      action,
      websiteUrl,
      source: 'performance-section'
    });
  };
  return /*#__PURE__*/_jsx("a", {
    href: `${url}&${parsedUtmParams}`,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `results.performance.cta.button${alt}`
    })
  });
});
const PerformancePage = ({
  websiteGrade,
  hideCTAs = false
}) => {
  const grade = websiteGrade.performanceAudit.grade;
  const websiteUrl = websiteGrade.domain;
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered performance-page",
    id: "performance",
    "data-reagan-selector": "performance-page",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(ResultHeaderIllustration, {
          name: "design-manager"
        }), /*#__PURE__*/_jsx(PageScore, {
          score: grade,
          overallScore: ScoreConstants.PERFORMANCE_OVERALL
        }), /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.performance.title"
          })
        }), /*#__PURE__*/_jsx(Subtitle, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.performance.description"
          })
        }), !hideCTAs && /*#__PURE__*/_jsx(ResultCtaBanner, {
          use: "trophy",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "results.performance.cta.info",
            options: {
              ctaButton: /*#__PURE__*/_jsx(CTAButton, {
                websiteUrl: websiteUrl
              })
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "results-section radial-results-section",
          children: /*#__PURE__*/_jsx(ResultSection, {
            websiteGrade: websiteGrade,
            results: PerformanceData.topResults
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "results-section",
          children: /*#__PURE__*/_jsx(ResultSection, {
            websiteGrade: websiteGrade,
            results: PerformanceData.middleResults
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "results-section bottom-results",
          children: /*#__PURE__*/_jsx(ResultSection, {
            websiteGrade: websiteGrade,
            results: PerformanceData.bottomResults
          })
        })]
      })
    })
  });
};
export default PerformancePage;